import { Button } from "../ui/Button";

interface PagoReintentoCardProps {
  title?: string;
  description?: string;
  onRetry: () => void | Promise<void>;
  loading?: boolean;
  error?: string | null;
  retryLabel?: string;
  retryDisabled?: boolean;
  children?: React.ReactNode;
}

export function PagoReintentoCard({
  title = "El pago no se ha completado",
  description = "No hace falta volver a rellenar tus datos: puedes reintentar el pago con tarjeta.",
  onRetry,
  loading = false,
  error = null,
  retryLabel = "Reintentar pago con tarjeta",
  retryDisabled = false,
  children,
}: PagoReintentoCardProps) {
  return (
    <>
      <h1 className="text-xl font-semibold text-[#2C2C2C]">{title}</h1>
      <p className="mt-2 text-sm text-gray-600">{description}</p>
      {error && <p className="mt-3 text-sm text-red-600">{error}</p>}
      {children}
      <Button
        type="button"
        className="mt-6 w-full sm:w-auto"
        loading={loading}
        disabled={loading || retryDisabled}
        onClick={() => void onRetry()}
      >
        {retryLabel}
      </Button>
      {loading && (
        <p className="mt-2 text-center text-sm text-gray-500">Redirigiendo al banco…</p>
      )}
    </>
  );
}
